import types from "../types/types";
import { getRoles as getRolesAPI } from "../components/selector/getRoles";

export const getRoles = async () => {

    const rolesAPI = getRolesAPI();

    return (disptach) => {
        
        rolesAPI.then( (response) =>{
            
            disptach(roles(response));
        })
        .catch(err => {
            console.log("getRoles error: " + err);
        });
    }
}

export const roles = (roles) => ({
    type: types.roles_list,
    roles: roles 
});

export default {
    getRoles,
    roles
}